<ui-page-header>Bestelldetails</ui-page-header>

@if (orderResource.isLoading()) {
  <mat-card>
    <mat-card-content>
      <ui-order-history-record-skeleton></ui-order-history-record-skeleton>
    </mat-card-content>
  </mat-card>
} @else if (isNotFound()) {
  <h3>Die Bestellung konnte nicht gefunden werden.</h3>
} @else if (orderResource.error()) {
  <ui-alert
    theme="error"
    message="Beim Laden der Bestellung ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal."
  ></ui-alert>
} @else {
  <mat-card class="order-details">
    <mat-card-content>
      <ui-order-history-details
        [order]="orderResource.value()!"
      ></ui-order-history-details>
    </mat-card-content>
  </mat-card>

  <mat-card class="order-categories">
    <mat-card-content>
      <div class="item-toolbar">
        <ui-search-input
          [searchText]="searchTerm()"
          (searchChanged)="searchTerm.set($event)"
          placeholder="Artikel durchsuchen"
        ></ui-search-input>

        <ui-order-history-record-filter
          [nodes]="nodes()"
          [filter]="filter()"
          [sort]="sort()"
          (filterChange)="filter.set($event)"
          (sortChange)="sort.set($event)"
        ></ui-order-history-record-filter>
      </div>

      @if (canReorder() && selectableItems().length) {
        <mat-checkbox
          class="select-available"
          [checked]="allSelectableSelected()"
          (change)="selectAllAvailable($event.checked)"
        >
          Verfügbare auswählen
        </mat-checkbox>
      }

      @for (node of visibleNodes(); track node.id) {
        <ui-expander
          [title]="node.label"
          [expanded]="true"
        >
          @for (child of node.children; track child.id) {
            <div class="sub-category">
              <p>{{ child.label }}</p>
              @for (item of child.items; track item.id) {
                @if (item.productData) {
                  <ui-order-history-item
                    uiProductImpression
                    uiProductTrackingList="bestellübersicht"
                    [product]="item.productData"
                    [position]="itemPositions().get(item) ?? 0"
                    [availability]="trackingAvailability.available"
                    [orderItem]="item"
                    [canReorder]="canReorder()"
                    [showCheckbox]="canReorder()"
                    [selected]="isSelected(item)"
                    (selectedChange)="itemSelectionChanged(item, $event)"
                    (quantityChanged)="onItemQuantityChanged(item, $event)"
                  ></ui-order-history-item>
                } @else {
                  <ui-order-history-item
                    uiPartialProductImpression
                    uiProductTrackingList="bestellübersicht"
                    [position]="itemPositions().get(item) ?? 0"
                    [partialProduct]="item"
                    [orderItem]="item"
                    [canReorder]="canReorder()"
                  ></ui-order-history-item>
                }
              }
            </div>
          }
        </ui-expander>
      } @empty {
        <p class="no-results">
          Zu Ihrer Auswahl konnten keine Artikel gefunden werden.
        </p>
      }
    </mat-card-content>
  </mat-card>
}

<ng-template #selectionActions>
  <ui-order-selection-bar
    [selectedCount]="selectedItems().length"
    [isLoading]="isAddToCartLoading()"
    (addToCartClicked)="addSelectedToCart()"
    (cancelled)="clearSelection()"
  ></ui-order-selection-bar>
</ng-template>
